// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-name {
  padding-left: 15px;
}
.profile-name h2 {
  padding: 0;
  margin: 0;
}
h3 {
  font-weight: 500;
  font-size: 20px;
}
.skill-level {
  min-width: 76px;
  display: inline-block;
}
.right-text {
  text-align: right;
  white-space: pre-wrap;
  word-break: break-word;
}
.turing-ui-v2-profile-work-history .content {
  margin-left: 5px !important;
}

.project-skills-list {
  display: flex;
  flex-wrap: wrap;
}

.project-skills-list > * {
  margin: 5px;
}

.side-project-item > h2{
  margin: 0;
}

.side-project-item > small{
  color: gray;
}

.custom-availability-modal .ant-modal-close {
  top: 25px;
  right: 18px;
}

.new-availability-spacing {
    margin-top: 28px;
  }

  .new-availability-spacing-2 {
    margin-top: 24px;
  }

@media (max-height: 768px) {
  .custom-availability-modal .ant-modal-content {
    padding: 0;
  }

  .custom-availability-modal .ant-modal-close {
    top: 16px;
  }
  .custom-availability-modal.ant-modal {
    width: 620px !important;
    height: 727px !important;
    top: 40px !important;
  }

  .custom-availability-modal span.ant-radio + * {
    padding-right: 0 !important;
  }

  .custom-availability-modal .ant-modal-header {
    padding: 32px;
    line-height: normal;
  }

  .custom-availability-modal .ant-modal-footer {
    padding: 20px 24px 24px;
  }

  .custom-availability-modal .ant-modal-title {
    line-height: normal;
    font-size: 20px;
    font-weight: normal;
    font-weight: 500;
  }

  .custom-availability-modal .ant-modal-body {
    padding: 0 27px 0 32px
  }
  .pretest-english-proficiency .ant-row-flex {
    margin-bottom: 16px !important;
  }

  .pretest-english-proficiency .pretest-section-title {
    line-height: 21px !important;
  }
  .availability-question .ant-card-body {
    padding: 8px 16px !important;
  }
  .availability-question .ant-row-flex {
    margin-bottom: 4px !important;
  }
  /* .pretest-option-title-row {
    height: 19px;
  } */

  .availability-question.ant-card {
    margin-bottom: 8px !important;
  }

  .availability-question .pretest-eng-pro-title {
    line-height: normal;
  }
  .new-availability-spacing {
    margin-top: 0 !important;
  }
  .new-availability-spacing-2 {
    margin-top: 0 !important;
  }
  .new-availability-term {
    margin-top: 24px !important;
  }

  .new-availability-term .pretest-section-title {
    line-height: 21px;
  }

  .new-availability-term .ant-row-flex {
    margin-bottom: 17px !important;
  }
  .pretest-availability-option .ant-radio-wrapper {
    margin-bottom: 12px !important;
    height: 19px !important;
  }

  .pretest-availability-option .ant-row-flex {
    margin-top: 32px !important;
    margin-bottom: 17px !important;
  }
  .pretest-availability-option .pretest-section-title {
    line-height: normal;
  }
  .pretest-availability-option-detail, .availability-question .pretest-eng-pro-detail {
    line-height: 16px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/profile/Profile.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;IACI,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE;EACF;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;;KAEG;;EAEH;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;;AAEF","sourcesContent":[".profile-name {\n  padding-left: 15px;\n}\n.profile-name h2 {\n  padding: 0;\n  margin: 0;\n}\nh3 {\n  font-weight: 500;\n  font-size: 20px;\n}\n.skill-level {\n  min-width: 76px;\n  display: inline-block;\n}\n.right-text {\n  text-align: right;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.turing-ui-v2-profile-work-history .content {\n  margin-left: 5px !important;\n}\n\n.project-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.project-skills-list > * {\n  margin: 5px;\n}\n\n.side-project-item > h2{\n  margin: 0;\n}\n\n.side-project-item > small{\n  color: gray;\n}\n\n.custom-availability-modal .ant-modal-close {\n  top: 25px;\n  right: 18px;\n}\n\n.new-availability-spacing {\n    margin-top: 28px;\n  }\n\n  .new-availability-spacing-2 {\n    margin-top: 24px;\n  }\n\n@media (max-height: 768px) {\n  .custom-availability-modal .ant-modal-content {\n    padding: 0;\n  }\n\n  .custom-availability-modal .ant-modal-close {\n    top: 16px;\n  }\n  .custom-availability-modal.ant-modal {\n    width: 620px !important;\n    height: 727px !important;\n    top: 40px !important;\n  }\n\n  .custom-availability-modal span.ant-radio + * {\n    padding-right: 0 !important;\n  }\n\n  .custom-availability-modal .ant-modal-header {\n    padding: 32px;\n    line-height: normal;\n  }\n\n  .custom-availability-modal .ant-modal-footer {\n    padding: 20px 24px 24px;\n  }\n\n  .custom-availability-modal .ant-modal-title {\n    line-height: normal;\n    font-size: 20px;\n    font-weight: normal;\n    font-weight: 500;\n  }\n\n  .custom-availability-modal .ant-modal-body {\n    padding: 0 27px 0 32px\n  }\n  .pretest-english-proficiency .ant-row-flex {\n    margin-bottom: 16px !important;\n  }\n\n  .pretest-english-proficiency .pretest-section-title {\n    line-height: 21px !important;\n  }\n  .availability-question .ant-card-body {\n    padding: 8px 16px !important;\n  }\n  .availability-question .ant-row-flex {\n    margin-bottom: 4px !important;\n  }\n  /* .pretest-option-title-row {\n    height: 19px;\n  } */\n\n  .availability-question.ant-card {\n    margin-bottom: 8px !important;\n  }\n\n  .availability-question .pretest-eng-pro-title {\n    line-height: normal;\n  }\n  .new-availability-spacing {\n    margin-top: 0 !important;\n  }\n  .new-availability-spacing-2 {\n    margin-top: 0 !important;\n  }\n  .new-availability-term {\n    margin-top: 24px !important;\n  }\n\n  .new-availability-term .pretest-section-title {\n    line-height: 21px;\n  }\n\n  .new-availability-term .ant-row-flex {\n    margin-bottom: 17px !important;\n  }\n  .pretest-availability-option .ant-radio-wrapper {\n    margin-bottom: 12px !important;\n    height: 19px !important;\n  }\n\n  .pretest-availability-option .ant-row-flex {\n    margin-top: 32px !important;\n    margin-bottom: 17px !important;\n  }\n  .pretest-availability-option .pretest-section-title {\n    line-height: normal;\n  }\n  .pretest-availability-option-detail, .availability-question .pretest-eng-pro-detail {\n    line-height: 16px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
